import { customerAlias } from './customerAlias';
import { productAlias } from './productAlias';

export function orderDescription(order: any): string | undefined {
  if(!order) return;
  let orderDescription = productAlias(order.product);
  let ids = `Order ID: <b>${order._id}</b>`;
  if(order.quotationId) {
    ids = `${ids} / Quotation ID: <b>${order.quotationId}</b>`;
  }
  orderDescription = `${orderDescription}\n${ids}`;
  const customerName = customerAlias(order.customer, false);
  if (customerName) {
    return `${customerName}\n${orderDescription}`;
  } else {
    return orderDescription;
  }
}